import React, { useMemo } from "react";
import "../../assets/css/ReRegArticulationLeftBox.css";
import ActionExpandableButtons from "../ActionExpandableButtons";

const stepsMap = {
    0: { label: "Select Qualification", description: "Select the qualification you want to progress to in the upcoming intake" },
    1: { label: "Review and Submit", description: "Confirm your selection and submit your articulation." }
}
function ReRegArticulationLeftBox(props) {
    const {
        currentStep,
        isArticulationOptionSelected,
        stepsAvailable,
        studentStatus,
        submitted,
        registration,
        setCurrentStep
    } = props;

    const steps = useMemo(() => {
        return stepsAvailable
            .filter(stepId => stepsMap[stepId])
            .map((stepId, idx) => {
                const isCompleted = submitted ? true : (idx === 0 && isArticulationOptionSelected);
                return {
                    ...stepsMap[stepId],
                    id: stepId,
                    displayIndex: idx + 1,
                    isActive: currentStep === idx,
                    isCompleted
                };
            });
    }, [currentStep, isArticulationOptionSelected, stepsAvailable, submitted]);

    const getRegistrationStatus = () => {
        if (submitted) {
            return (
                <span className={`info-value reg-status ${registration?.statusColor || "green"}`}>
                    <i className="fal fa-user-check"></i> {registration?.status || "Submitted"}
                </span>
            );
        }
        return registration?.per || studentStatus
            ? (
                <span className={`info-value reg-status ${registration?.statusColor || ""}`}>
                    <i className="fal fa-user-check"></i> {registration?.status}
                </span>
            ) : (
                <span className={`info-value reg-status ${registration?.statusColor || "red"}`}>
                    <i className="fal fa-user-times"></i> {registration?.status || "Not Submitted"}
                </span>
            );
    };

    const renderStep = ({ id, description, displayIndex, label, isActive, isCompleted }) => {
        const icon = (() => {
            if (isCompleted) {
                // Completed = green check
                return (
                    <div className="step-icon isCompleted">
                        <i className="fal fa-check"></i>
                    </div>
                );
            } else if (isActive) {
                // Current step
                return (
                    <div className="step-icon isActive">
                        {displayIndex}
                    </div>
                );
            } else {
                // Upcoming step
                return (
                    <div className="step-icon step-number">
                        {displayIndex}
                    </div>
                );
            }
        })();

        const goToStep = () => {
            if (id !== currentStep && !submitted) {
                // Go to another step if (1) not submitted and (2) it has data:
                if (id !== 1 || isArticulationOptionSelected) {
                    setCurrentStep(id);
                }
            }
        };

        return (
            <div className="step-row" key={id} onClick={goToStep}>
                {icon}
                <div className="step-content">
                    <div className="step-title">{label}</div>
                    <div>
                        {description}
                    </div>
                </div>
            </div>
        );
    };

    const getReRegStatus = () => {
        return (registration.reg_status.toLowerCase() === 'open' ? true : false) ? (
            <div className="status-badge in-progress">IN PROGRESS</div>
        ) : (
            <div className="status-badge closed">Closed</div>
        );
    };

    return (
        <div className="re-registration-detail-lft articulation-lft bg-white">
            <div className="re-registration-lft-head">
                <ActionExpandableButtons label="Back" link="/reregistration" />
                {getReRegStatus()}

                <h3 className="page-title">Articulation, Intake {registration.intake_number} {registration.intake_year}</h3>
                <div className="school-name">{registration.academy2}</div>

                <div className="intake-row">
                    <div className="intake-item">
                        <i className="fal fa-calendar-clock blue"></i>
                        Intake {registration.intake_number}, {registration.intake_year}
                    </div>
                    <div className="intake-item">
                        <i className="fal fa-calendar-alt blue"></i>
                        {registration.start_date} to {registration.end_date}
                    </div>
                </div>

                <hr />

                <div className="info-row">
                    <span className="info-label">Your Status:</span>
                    {getRegistrationStatus()}
                </div>

                <div className="info-row">
                    <span className="info-label">Close Date:</span>
                    <span className="info-value">
                        <i className="fal fa-calendar-alt blue"></i> {registration.end_date}
                    </span>
                </div>

                <hr />

                <div class="steps">
                    {steps.map((step) => renderStep(step))}
                </div>
            </div>
        </div>
    );
}

export default ReRegArticulationLeftBox;
